export default "__VITE_ASSET__DzUfdbfE__"